<template>
  <section class="local-tradingview">
    <div id="chart_wrapper" class="kline d-none">
      <div id="tv_chart_container"></div>
    </div>
  </section>
</template>
<script>
import { DataFeed, widget as TvWidget } from "tradingview-api";
import { MarketMarketService } from "@/services";
import { authMixin } from "@/mixins/authMixin";

const Stomp = require("stompjs");
const SockJS = require("sockjs-client");

const supported_resolutions = [
  "1",
  "5",
  "15",
  "30",
  "60",
  "240",
  "1D",
  "1W",
  "1M"
];
const intervalMap = {
  "1min": "1",
  "5min": "5",
  "15min": "15",
  "30min": "30",
  "1hour": "60",
  // '60min': '60',
  "4hour": "240",
  "1day": "1D",
  "1week": "1W",
  "1month": "1M"
  // '1mon': '1M'
};
export default {
  name: "localTradingView",
  mixins: [authMixin],
  props: {
    currentCoin: {
      type: Object
    }
  },
  data() {
    return {
      shapeData: [],
      studyData: [],
      subscribtion: {},
      widget: null,
      interval: "4hour",
      datafeed: new DataFeed({
        getBars: params => this.getBars(params),
        fetchResolveSymbol: () => this.resolveSymbol(),
        fetchConfiguration: () => {
          return new Promise(resolve => {
            resolve({
              supported_resolutions
            });
          });
        }
      })
    };
  },

  mounted() {
    this.getKline();
  },
  watch: {
    "$vuetify.theme.dark": {
      handler() {
        if (this.widget) {
          this.getKline();
        }
      },
      immediate: true // Triggers on component creation
    }
  },
  methods: {
    resolveSymbol() {
      return new Promise(resolve => {
        const symbol = this.currentCoin.symbol;
        resolve({
          name: symbol,
          full_name: symbol,
          description: symbol,
          type: "crypto",
          session: "24x7",
          exchange: "Excoino",
          pricescale: Math.pow(10, this.currentCoin.frontBaseCoinScale),
          listed_exchange: symbol,
          timezone: "Asia/Tehran",
          format: "price",
          minmov: 1,
          // volume_precision: info['value-precision'],
          has_intraday: true,
          supported_resolutions,
          has_weekly_and_monthly: true,
          volume_precision: 8
        });
      });
    },
    async getBars(params) {
      const symbol = this.currentCoin.symbol;
      const size = window.innerWidth;
      if (
        !params.firstDataRequest /** Whether to request historical data for the first time */
      ) {
        // Huobi API temporarily does not support segmented query historical data
        return {
          bars: [],
          meta: {
            noData: true
          }
        };
      }
      if (params.resolution !== intervalMap[this.interval]) {
        this.unsubscribeKLine();
        for (const key in intervalMap) {
          if (intervalMap[key] === params.resolution) {
            this.interval = key;
          }
        }
      }
      const res = await MarketMarketService.getKLineData({
        symbol,
        from: params.from * 1000,
        to: params.firstDataRequest ? new Date().getTime() : params.to * 1000,
        resolution: intervalMap[this.interval],
        size: size > 2000 ? 2000 : size
      });
      if (
        params.resolution === intervalMap[this.interval] &&
        params.firstDataRequest &&
        res.data &&
        res.data.length
      ) {
        this.subscribeKLine(this.interval);
        if (this.isAuth) {
          const chart = this.widget.activeChart();
          chart.removeAllShapes();
          chart.removeAllStudies();

          // Fetch and redraw indicators after a short delay to ensure chart is ready
          setTimeout(() => {
            this.getIndicators();
          }, 100);
        }
      }

      document.getElementById("chart_wrapper").classList.add("d-block");
      //loading ezafe beshe

      if (!res.data || !res.data.length) {
        return {
          bars: [],
          meta: { noData: true }
        };
      }
      const list = [];
      for (let i = 0; i < res.data.length; i++) {
        const item = res.data[i];
        if (params.resolution === "1D") {
          list.push({
            time: item[0] + 12600000,
            open: item[1],
            high: item[2],
            low: item[3],
            close: item[4],
            volume: item[5]
          });
        } else if (params.resolution === "1W") {
          list.push({
            time: item[0] + 99000000,
            open: item[1],
            high: item[2],
            low: item[3],
            close: item[4],
            volume: item[5]
          });
        } else if (params.resolution === "1M") {
          list.push({
            time: item[0] + 16200000,
            open: item[1],
            high: item[2],
            low: item[3],
            close: item[4],
            volume: item[5]
          });
        } else {
          list.push({
            time: item[0],
            open: item[1],
            high: item[2],
            low: item[3],
            close: item[4],
            volume: item[5]
          });
        }
      }
      list.sort((l, r) => (l.time > r.time ? 1 : -1));
      return {
        bars: list,
        meta: {
          noData: !list.length
        }
      };
    },
    getKline() {
      let config = {
        autosize: true,
        height: 320,
        fullscreen: true,
        theme: this.$vuetify.theme.dark ? "dark" : "light",
        studies_overrides: {
          "volume.show ma": true
        },
        disabled_features: [
          "header_compare",
          "create_volume_indicator_by_default"
        ],
        symbol: this.symbol,
        interval: intervalMap[this.interval], // default candlestick period
        timezone: "Asia/Tehran",
        // toolbar_bg: "#18202a",
        container_id: "tv_chart_container",
        datafeed: this.datafeed,
        library_path: "/panel/charting_library/",
        locale: "en",
        debug: false
      };

      this.widget = new TvWidget(config);
      this.widget.onChartReady(() => {
        this.widget
          .activeChart()
          .onIntervalChanged()
          .subscribe(null, (interval, timeframeObj) => {
            this.handleTimeframeChange(interval, timeframeObj);
          });
      });
    },
    async handleTimeframeChange() {
      // const chart = this.widget.activeChart();
      // if (this.isAuth) {
      //   await this.setIndicators()
      //
      //
      //    chart.removeAllShapes();
      //    chart.removeAllStudies();
      //    chart.resetData();
      //
      //   await this.getIndicators()
      // }

      const chart = this.widget.activeChart();

      if (this.isAuth) {
        // Clear existing data
        this.shapeData = [];
        this.studyData = [];

        // Remove existing shapes and studies
        chart.removeAllShapes();
        chart.removeAllStudies();

        // Fetch and redraw indicators after a short delay to ensure chart is ready
        setTimeout(() => {
          this.getIndicators();
        }, 100);
      }
    },
    subscribeKLine(resolution) {
      let stompClient = null;
      let socket = new SockJS(
        `${process.env.VUE_APP_BASE_MARKET}/market/market-ws`
        // `https://market-api.excoino.com/market/market-ws`
      );
      stompClient = Stomp.over(socket);
      stompClient.debug = false;
      stompClient.connect({}, () => {
        this.subscribtion = stompClient.subscribe(
          `/topic/market/kline/${this.currentCoin.symbol}/${resolution}`,
          msg => {
            let resp = JSON.parse(msg.body);
            if (resolution === "1day") {
              this.datafeed.updateKLine({
                time: resp.time + 12600000,
                open: resp.openPrice,
                high: resp.highestPrice,
                low: resp.lowestPrice,
                close: resp.closePrice,
                volume: resp.volume
              });
            } else if (resolution === "1week") {
              this.datafeed.updateKLine({
                time: resp.time + 99000000,
                open: resp.openPrice,
                high: resp.highestPrice,
                low: resp.lowestPrice,
                close: resp.closePrice,
                volume: resp.volume
              });
            } else if (resolution === "1month") {
              this.datafeed.updateKLine({
                time: resp.time + 16200000,
                open: resp.openPrice,
                high: resp.highestPrice,
                low: resp.lowestPrice,
                close: resp.closePrice,
                volume: resp.volume
              });
            } else {
              this.datafeed.updateKLine({
                time: resp.time,
                open: resp.openPrice,
                high: resp.highestPrice,
                low: resp.lowestPrice,
                close: resp.closePrice,
                volume: resp.volume
              });
            }
          }
        );
      });
    },
    unsubscribeKLine() {
      this.subscribtion.unsubscribe();
    },
    updateStudyInputs(chart, studyId, inputName, newValue) {
      // Get the study object by its ID
      const study = chart.getStudyById(studyId)._study;

      if (!study || !study._properties || !study._properties.inputs) {
        console.error("Study or inputs not found");
        return;
      }

      // Access the specific input and update its value
      const input = study._properties.inputs[inputName];
      if (input) {
        input._value = newValue;
        // Trigger update if necessary (depends on implementation)
        if (input._listeners) {
          input._listeners.fire();
        }
      } else {
        console.error(`Input ${inputName} not found`);
      }
    },
    getIndicators() {
      if (!this.widget) return;

      const chart = this.widget.activeChart();
      MarketMarketService.getChartData(this.$route.params.pair).then(
        response => {
          let config = response.data.data;

          // Handle single config object
          if (!Array.isArray(config)) {
            config = [config];
          }

          // Track existing shape prices to prevent duplicates
          const existingShapePrices = new Set();

          config.forEach(item => {
            if (item.type === "SHAPE") {
              const inputs = JSON.parse(item.data.inputs);

              // Create price signature for comparison
              const priceSignature = inputs.map(input => input.price).join(",");

              if (!existingShapePrices.has(priceSignature)) {
                existingShapePrices.add(priceSignature);
                chart.createMultipointShape(inputs, {
                  shape: item.data.name,
                  ...item.data.properties
                });
              }
            } else if (item.type === "STUDY") {
              const inputs = JSON.parse(item.data.inputs);
              chart
                .createStudy(item.data.name, false, false, null, {})
                .then(result => {
                  for (const resultKey in inputs) {
                    this.updateStudyInputs(
                      chart,
                      result,
                      resultKey,
                      inputs[resultKey]
                    );
                  }
                });
            }
          });
        }
      );
    },
    async setIndicators() {
      if (!this.widget) return;
      const chart = this.widget.activeChart();
      const shapes = chart.getAllShapes();
      // Process shapes

      shapes.forEach(shape => {
        const shapeDetails = chart.getShapeById(shape.id);
        const inputs = shapeDetails._source._timePoint.map(item => ({
          time: item.time_t,
          price: item.price
        }));
        console.log(inputs);
        const isDuplicatePrice = this.shapeData.some(existingShape => {
          const existingInputs = JSON.parse(existingShape.data.inputs);
          return existingInputs.every(
            (input, index) => input.price === inputs[index]?.price
          );
        });
        if (!isDuplicatePrice) {
          this.shapeData.push({
            type: "SHAPE",
            data: {
              name: shape.name,
              inputs: JSON.stringify(inputs),
              properties: ""
            }
          });
        }
      });

      // Process studies
      const studies = await chart.getAllStudies();
      studies.forEach(study => {
        const studyObj = chart.getStudyById(study.id);
        const currentInputs = studyObj._study._inputs;

        // Check for studies with same price inputs
        const isDuplicatePrice = this.studyData.some(existingStudy => {
          const existingInputs = JSON.parse(existingStudy.data.inputs);
          // Compare numerical (price) values only
          return Object.keys(existingInputs).every(key =>
            typeof existingInputs[key] === "number"
              ? existingInputs[key] === currentInputs[key]
              : true
          );
        });

        if (!isDuplicatePrice) {
          this.studyData.push({
            type: "STUDY",
            data: {
              name: study.name,
              inputs: JSON.stringify(currentInputs),
              properties: ""
            }
          });
        }
      });
      if (shapes.length === 0) {
        this.shapeData = [];
      }
      if (studies.length === 0) {
        this.studyData = [];
      }
      console.log([...this.shapeData, ...this.studyData]);
      MarketMarketService.saveChartData({
        symbol: this.currentCoin.symbol.replace("/", "_"),
        data: [...this.shapeData, ...this.studyData]
      });
    }
  },
  beforeDestroy() {
    this.setIndicators();
  }
};
</script>
